import type { FieldConfig } from '@/mocks/questionnaire';
import { chipClass } from '@/pages/home/components/fields/styles';

interface ChipsFieldProps {
  field: FieldConfig;
  value: string;
  onChange: (value: string) => void;
}

export default function ChipsField({ field, value, onChange }: ChipsFieldProps) {
  return (
    <div>
      <span className="block text-sm font-semibold text-foreground-900 mb-2">
        {field.label}
        {field.hint ? (
          <span className="text-xs font-normal text-foreground-400 ml-1">{field.hint}</span>
        ) : null}
      </span>
      <div className="flex flex-wrap gap-2">
        {(field.options || []).map((option) => {
          const selected = value === option.label;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(selected ? '' : option.label)}
              className={chipClass(selected)}
            >
              {option.label}
            </button>
          );
        })}
      </div>
      <input type="hidden" name={field.name} value={value} readOnly />
    </div>
  );
}